@if (file) {
<ng-template #downloadButton>
    <button class="btn btn-secondary" role="button" (click)="download.next(file)" type="button">
        {{file.name}}
        <span class="badge text-bg-secondary">
            {{prettyBytes(file.size)}}
        </span>
    </button>
</ng-template>
<div class="row align-items-center">
    <div class="col-auto p-2">
        <fa-icon [icon]="icon" (click)="download.next(file)" size="5x"></fa-icon>
    </div>
    <div class="col p-2">
        @if (allowDelete) {
        <div class="btn-group" ngbDropdown>
            <ng-container [ngTemplateOutlet]="downloadButton"></ng-container>
            <button class="btn btn-secondary dropdown-toggle" role="button" ngbDropdownToggle type="button"
                title="Delete file">
                <fa-icon [icon]="faTrash"></fa-icon>
            </button>
            <div class="dropdown-menu" ngbDropdownMenu>
                <h6 class="dropdown-header" i18n>Delete file?</h6>
                <span role="button" ngbDropdownItem i18n (click)="delete.next(file)">Yes</span>
                <span role="button" ngbDropdownItem i18n>No</span>
            </div>
        </div>
        }
        @else {
        <ng-container [ngTemplateOutlet]="downloadButton"></ng-container>
        }
    </div>
</div>
}
